import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ConfirmButton = styled(Button)(({ theme }) => ({
  color: theme.palette.button.confirm.color,
  backgroundColor: theme.palette.button.confirm.background,
  '&:hover': {
    color: theme.palette.button.confirm.color,
    backgroundColor: theme.palette.button.confirm.backgroundHover,
  },
  '&:disabled': {
    color: theme.palette.button.confirm.color,
    backgroundColor: theme.palette.button.confirm.backgroundDisabled,
  },
}));

export const CancelButton = styled(Button)(({ theme }) => ({
  color: theme.palette.button.cancel.color,
  backgroundColor: theme.palette.button.cancel.background,
  '&:hover': {
    backgroundColor: theme.palette.button.cancel.backgroundHover,
  },
  '&:disabled': {
    color: theme.palette.button.cancel.color,
    backgroundColor: theme.palette.button.cancel.backgroundDisabled,
  },
}));

export const AppleSignInButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.button.apple.background,
  color: theme.palette.button.apple.color,
  '&:hover': {
    color: theme.palette.button.apple.color,
    backgroundColor: theme.palette.button.apple.backgroundHover,
  },
  '&:disabled': {
    color: theme.palette.button.apple.color,
    backgroundColor: theme.palette.button.apple.backgroundDisabled,
  },
}));

export const PopupButton = styled(Button)(({ theme }) => ({
  color: theme.palette.dialog.primaryButton.color,
  backgroundColor: theme.palette.dialog.primaryButton.background,
  '&:hover': {
    color: theme.palette.dialog.primaryButton.color,
    backgroundColor: theme.palette.dialog.primaryButton.backgroundHover,
  },
}));
